"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var data = [{
  id: 1,
  title: "Pendentif ",
  price: "€ 5500",
  image: "https://ik.imagekit.io/marketcube/platform/no-image.png"
}, {
  id: 2,
  title: "Pendentif",
  price: "€ 5500",
  image: "https://ik.imagekit.io/marketcube/platform/no-image.png"
}, {
  id: 3,
  title: "Pendentif",
  price: "€ 5500",
  image: "https://ik.imagekit.io/marketcube/platform/no-image.png"
}, {
  id: 4,
  title: "Pendentif",
  price: "€ 5500",
  image: "https://ik.imagekit.io/marketcube/platform/no-image.png"
}];

exports.default = data;